import React from 'react';
import { Link } from 'react-router-dom';
import '../Css_files/Blog_c1.css';
import Footer from './Footer';

const BlogPage_c1 = () => {
  return (
    <div className="blog-page">
      <header className="blog-header">
        <h1 className="main-title">Explore Technical & Creative Domains</h1>
        <p className="subtitle">Discover knowledge across engineering, technology, and creative fields</p>
      </header>

      <main className="blog-content">
        <div className="categories-grid">
          
          <Link to="/blog1" className="category-card-link" style={{ '--card-color': '#FF6B6B' }}>
            <section className="category-card">
              <div className="card-icon">⚙️</div>
              <div className="card-content">
                <h3 className="card-title">Mechanical Engineering</h3>
                <p className="card-description">
                  Explore the world of mechanical systems, thermodynamics, and CAD tools. Discover real-world mechanical innovations, manufacturing processes, and the latest developments in automotive and aerospace engineering.
                </p>
              </div>
              <div className="card-footer">
                <span className="explore-text">Explore Topics</span>
                <span className="arrow">→</span>
              </div>
            </section>
          </Link>

          <Link to="/blog2" className="category-card-link" style={{ '--card-color': '#4ECDC4' }}>
            <section className="category-card">
              <div className="card-icon">🏗️</div>
              <div className="card-content">
                <h3 className="card-title">Civil Engineering</h3>
                <p className="card-description">
                  Dive into structural engineering, construction techniques, and infrastructure development. Learn about sustainable building practices, urban planning, and the engineering marvels that shape our cities.
                </p>
              </div>
              <div className="card-footer">
                <span className="explore-text">Explore Topics</span>
                <span className="arrow">→</span>
              </div>
            </section>
          </Link>

          <Link to="/blog3" className="category-card-link" style={{ '--card-color': '#45B7D1' }}>
            <section className="category-card">
              <div className="card-icon">📡</div>
              <div className="card-content">
                <h3 className="card-title">Electronics & Communication</h3>
                <p className="card-description">
                  Understand communication systems, signal processing, and wireless technologies. Explore the fundamentals of electronics that power our connected world and emerging IoT applications.
                </p>
              </div>
              <div className="card-footer">
                <span className="explore-text">Explore Topics</span>
                <span className="arrow">→</span>
              </div>
            </section>
          </Link>

          <Link to="/blog4" className="category-card-link" style={{ '--card-color': '#96CEB4' }}>
            <section className="category-card">
              <div className="card-icon">🔌</div>
              <div className="card-content">
                <h3 className="card-title">Electronics Engineering</h3>
                <p className="card-description">
                  Master circuit design, embedded systems, and hardware development. Learn about microcontrollers, PCB design, and the electronic components that drive modern technology innovation.
                </p>
              </div>
              <div className="card-footer">
                <span className="explore-text">Explore Topics</span>
                <span className="arrow">→</span>
              </div>
            </section>
          </Link>

          <Link to="/blog5" className="category-card-link" style={{ '--card-color': '#FFEAA7' }}>
            <section className="category-card">
              <div className="card-icon">💻</div>
              <div className="card-content">
                <h3 className="card-title">Computer Science</h3>
                <p className="card-description">
                  Journey through programming languages, algorithms, and software development. Discover data structures, artificial intelligence, and the computational thinking that powers our digital age.
                </p>
              </div>
              <div className="card-footer">
                <span className="explore-text">Explore Topics</span>
                <span className="arrow">→</span>
              </div>
            </section>
          </Link>

          <Link to="/blog6" className="category-card-link" style={{ '--card-color': '#DDA0DD' }}>
            <section className="category-card">
              <div className="card-icon">🎨</div>
              <div className="card-content">
                <h3 className="card-title">Arts & Design</h3>
                <p className="card-description">
                  Explore creative design principles, visual arts, and artistic techniques. Learn about color theory, composition, and the intersection of technology with traditional and digital art forms.
                </p>
              </div>
              <div className="card-footer">
                <span className="explore-text">Explore Topics</span>
                <span className="arrow">→</span>
              </div>
            </section>
          </Link>

          <Link to="/blog7" className="category-card-link" style={{ '--card-color': '#FFB6C1' }}>
            <section className="category-card">
              <div className="card-icon">🎬</div>
              <div className="card-content">
                <h3 className="card-title">Multimedia Technology</h3>
                <p className="card-description">
                  Discover digital media creation, graphics design, and animation techniques. Master video editing, 3D modeling, and the tools that bring creative visions to life in the digital realm.
                </p>
              </div>
              <div className="card-footer">
                <span className="explore-text">Explore Topics</span>
                <span className="arrow">→</span>
              </div>
            </section>
          </Link>

        </div>
      </main>

      {/* <Footer/> */}
    </div>
  );
};

export default BlogPage_c1;
